<div class="wrapper">
  <div class="name profile-menu-item">
    <orbit-fa-icon [iconName]="faUser" />
    <span>{{ name() }}</span>
  </div>
  <div class="email profile-menu-item">
    <orbit-fa-icon [iconName]="faEnvelope" />
    <span>{{ email() }}</span>
  </div>
</div>

<div class="button-wrapper">
  <orbit-button [label]="resetPasswordButtonLabel()" (onClick)="resetPasswordClicked()" />
  <orbit-button [label]="logoutButtonLabel()" (onClick)="logoutClicked()" />
</div>

<orbit-fa-icon class="bubbleArrow" [iconName]="bubbleArrow" />
